import Icon from '../components/Icon';

const CloseLoop = Icon(
  'close-loop',
  <>
    <path d="M9.53 3.47a.75.75 0 0 0-1.06 1.06l1.72 1.72H7.5a6.75 6.75 0 0 0 0 13.5h9a6.75 6.75 0 0 0 0-13.5H15a.75.75 0 0 0 0 1.5h1.5a5.25 5.25 0 1 1 0 10.5h-9a5.25 5.25 0 1 1 0-10.5h2.69L8.47 9.47a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06z" />
  </>
);

export default CloseLoop;
